import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "lti-tools/mcgrawhill",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "mcgrawhill-lti-portal" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
